import React from "react";
import "../../../operations/pages/DetailsPage/DetailsScreen.css";

const feedbackOptions = [
  "All good",
  "Minor observation",
  "Critical issues observed",
  "Enhancement Suggestion",
];

const FeedbackPopup = ({
  isOpen,
  onClose,
  selectedObservation,
  setSelectedObservation,
  observationText,
  setObservationText,
  onSubmit,
  isSubmitting,
  isFeedbackGiven,
}) => {
  if (!isOpen) return null;

  return (
    <div className="feedback-overlay">
      <div className="feedback-popup-content">
        <h3 className="pop-main-title">
          {isFeedbackGiven
            ? "Feedback is submitted, you can update it again"
            : "Submit Product Feedback"}
        </h3>

        <p className="feedback-instruction-text">
          {isFeedbackGiven
            ? "Your previous feedback is saved. Feel free to edit below:"
            : "Here is my key observation from this recording insight:"}
        </p>

        <div className="feedback-options-list">
          {feedbackOptions.map((text, i) => (
            <div
              key={i}
              className="feedback-option-row"
              onClick={() => setSelectedObservation(i + 1)}
            >
              <span className="option-text">
                {i + 1}. {text}
              </span>
              <div
                className={`custom-radio ${
                  selectedObservation === i + 1 ? "active" : ""
                }`}
              />
            </div>
          ))}
        </div>

        <div className="observation-input-container">
          <label className="obs-label-text">Observations:</label>
          <textarea
            value={observationText}
            onChange={(e) => setObservationText(e.target.value)}
            placeholder="Write your feedback here..."
          />
        </div>

        <div className="feedback-footer">
          <span className="feedback-cancel-text" onClick={onClose}>
            Close
          </span>
          <button
            className="feedback-submit-btn"
            onClick={onSubmit}
            disabled={isSubmitting}
            style={{
              backgroundColor: isFeedbackGiven ? "#28a745" : "#1b456b",
            }}
          >
            {isSubmitting
              ? "Processing..."
              : isFeedbackGiven
                ? "Update Feedback"
                : "Submit Feedback"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPopup;
